import { localstorageGetItem, localstorageSetItem, } from "@warda/library-ui/localstorage";
import { STORAGE_KEY } from ".";
import addQueryParamsToUrl from "../../../utils/addQueryParamsToUrl";
import { SHAREPAGE_TOKEN } from "../constants";
const getStorageData = () => {
    const data = localstorageGetItem(STORAGE_KEY, {});
    return data;
};
const setStorageData = (data) => {
    localstorageSetItem(STORAGE_KEY, data);
};
export const setAccessCodeTokenForPageCode = ({ pageCode, idToken, expiresIn, }) => {
    const data = getStorageData();
    const expires = Date.now() + (expiresIn - 10) * 1000;
    const accessCodeInfo = {
        idToken,
        expires,
    };
    data[pageCode] = accessCodeInfo;
    setStorageData(data);
};
export const getValidAccessCodeTokenForPageCode = (pageCode) => {
    if (!pageCode)
        return null;
    const data = getStorageData();
    const entry = data === null || data === void 0 ? void 0 : data[pageCode];
    if (!entry)
        return null;
    if (entry.expires < Date.now()) {
        delete data[pageCode];
        setStorageData(data);
        return null;
    }
    return entry.idToken;
};
export const removeAccessCodeTokenForPageCode = (pageCode) => {
    const data = getStorageData();
    if (pageCode in data) {
        delete data[pageCode];
        setStorageData(data);
        return true;
    }
    return false;
};
export const getPageCode = () => {
    const query = new URLSearchParams(window.location.search);
    if (query.has(SHAREPAGE_TOKEN))
        return query.get(SHAREPAGE_TOKEN);
    return null;
};
export const getAccessCodeToken = () => {
    const pageCode = getPageCode();
    const accessCodeToken = getValidAccessCodeTokenForPageCode(pageCode);
    return accessCodeToken;
};
export const getSharePageAuthorization = () => {
    const accessCodeToken = getAccessCodeToken();
    return accessCodeToken ? `Bearer ${accessCodeToken}` : undefined;
};
export const getSharePageAuthorizationHeaders = () => {
    const authorization = getSharePageAuthorization();
    return authorization ? { Authorization: authorization } : undefined;
};
export const addAccessCodeTokenToUrl = (base, params = {}) => {
    return addQueryParamsToUrl(base, {
        ...params,
        accessCode: getPageCode(),
    });
};
